import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { UsersPage } from '../modules/users/ui/pages/UsersPage';

export const Route = createFileRoute('/_authenticated/dashboard/users')({
  // User management is org_admin-only. Backend RBAC is the source of truth; this
  // guard keeps lower roles from reaching the screen by direct URL.
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    if (session.user.role !== 'org_admin') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: UsersPage,
  staticData: {
    breadcrumb: ['Manage', 'Users'],
  },
});
